import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import {
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { onePagerLayout } from "./one-pager-layout.styles";

export function PlayOnePagerColumns({
  division,
  leaderboard,
  programs,
}: {
  readonly division: string | null;
  readonly leaderboard: ReactNode;
  readonly programs: ReactNode;
}) {
  return (
    <main id="main" tabIndex={-1} {...stylex.props(onePagerLayout.grid)}>
      <section
        {...stylex.props(onePagerLayout.card)}
        aria-labelledby="op-board"
      >
        <div {...stylex.props(styles.cardTitle)}>
          <h2 id="op-board" {...stylex.props(onePagerLayout.headingText)}>
            Leaderboard
          </h2>
          <span {...stylex.props(onePagerLayout.cardNote)}>{division}</span>
        </div>
        {leaderboard}
      </section>
      <section
        {...stylex.props(onePagerLayout.card)}
        aria-labelledby="op-programs"
      >
        <h2 id="op-programs" {...stylex.props(styles.cardTitle)}>
          Programs released here
        </h2>
        <h3 {...stylex.props(styles.championTitle)}>Your champion</h3>
        {programs}
      </section>
    </main>
  );
}

const styles = stylex.create({
  cardTitle: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    marginTop: 0,
    marginInline: 0,
    marginBottom: spacing.space10,
    fontFamily: fonts.mono,
    fontSize: fontSizes.reading,
    fontWeight: 600,
    letterSpacing: "0.02em",
  },
  championTitle: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    marginTop: 0,
    marginInline: 0,
    marginBottom: spacing.space6,
    fontSize: fontSizes.small,
    fontWeight: 600,
  },
});
